export default "__VITE_ASSET__a06c9290__"